module.exports = __webpack_public_path__ + "img/spiral-details22.a563bfb8.png";